<template>
  <div class="box">
    <div class="p-5 border-b border-gray-200 dark:border-dark-5">
      <h2 class="font-medium text-base">{{ $t('text.addressInformation') }}</h2>
    </div>
    <div class="p-5">
      <InputSelect
        :label="$t('text.city')"
        v-model.number="vForm.cityId.$model"
        :options="cities"
        value-key="id"
        :vuelidate="vForm.cityId"
        input-class="login__input input--lg"
        @input="onChangeCity()"
      />

      <InputSelect
        :label="$t('text.district')"
        v-model.number="vForm.districtId.$model"
        :options="districts"
        value-key="id"
        :vuelidate="vForm.districtId"
        input-class="login__input input--lg"
        @input="onChangeDistrict()"
      />

      <InputSelect
        :label="$t('text.khoroo')"
        v-model.number="vForm.horooId.$model"
        :options="horoos"
        value-key="id"
        :vuelidate="vForm.horooId"
        input-class="login__input input--lg"
      />

      <InputString
        :label="$t('text.buildingStreet')"
        v-model.trim="vForm.buildingStreet.$model"
        :vuelidate="vForm.buildingStreet"
        input-class="login__input input--lg"
      />
      <InputString
        :label="$t('text.doorNumber')"
        v-model.trim="vForm.doorNumber.$model"
        :vuelidate="vForm.doorNumber"
      />
    </div>
  </div>
</template>

<script>
import InputString from '@/components/ui/input/InputString';
import InputSelect from '@/components/ui/input/InputSelect';

export default {
  props: {
    form: Object,
    vForm: Object,
    cities: Array,
  },

  components: {
    InputString,
    InputSelect,
  },

  computed: {
    districts() {
      const index = this.cities.findIndex(item => item.id === this.form.cityId);
      if (index > -1) {
        return this.cities[index].districts;
      }
      return [];
    },
    horoos() {
      const index = this.districts.findIndex(item => item.id === this.form.districtId);
      if (index > -1) {
        return this.districts[index].horoos;
      }
      return [];
    },
  },

  methods: {
    onChangeCity() {
      this.vForm.districtId.$model = null;
      this.vForm.horooId.$model = null;
    },
    onChangeDistrict() {
      this.vForm.horooId.$model = null;
    },
  },
};
</script>
